import { object, string } from 'yup';
import { IForgotPasswordValidationSchema } from 'views/Auth/ForgotPassword/interfaces/IForgotPasswordValidationSchema';

export const forgotPasswordValidationSchema = object<IForgotPasswordValidationSchema>({
  username: string().required('Username Required'),
});

export default forgotPasswordValidationSchema;
